<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: 'i-lucide-wrench',
  },
  // Locked cards stand in for a skill the account has not unlocked yet, so
  // they carry a connect action instead of a switch.
  locked: {
    type: Boolean,
    default: false,
  },
  lockedLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['connect']);

const enabled = defineModel('enabled', { type: Boolean, default: false });
</script>

<template>
  <div
    class="flex gap-3 items-start p-4 rounded-xl outline outline-1 -outline-offset-1 outline-n-container"
    :class="locked ? 'bg-n-solid-1' : 'bg-n-solid-2'"
  >
    <span
      class="grid place-items-center size-8 rounded-lg flex-shrink-0"
      :class="locked ? 'bg-n-alpha-2' : 'bg-n-alpha-3'"
    >
      <span
        class="size-4"
        :class="[icon, locked ? 'text-n-slate-10' : 'text-n-slate-12']"
      />
    </span>
    <div class="flex flex-col gap-1 min-w-0 flex-1">
      <div class="flex items-center gap-2">
        <span
          class="text-sm font-medium truncate"
          :class="locked ? 'text-n-slate-11' : 'text-n-slate-12'"
        >
          {{ title }}
        </span>
        <span v-if="locked" class="i-lucide-lock size-3 text-n-slate-10" />
      </div>
      <p v-if="description" class="text-sm text-n-slate-11">
        {{ description }}
      </p>
    </div>
    <Button
      v-if="locked"
      :label="lockedLabel"
      link
      sm
      slate
      class="flex-shrink-0"
      @click="emit('connect')"
    />
    <Switch v-else v-model="enabled" class="mt-1" />
  </div>
</template>
